import { Link as MUILink, LinkProps as MUILinkProps } from '@mui/material';

export interface LinkProps extends MUILinkProps {}

export const Link = MUILink;
